import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import './slide.scss';

const Slide = ({ stops, selectedIndex, statePosition, selectionHandler,  error, disabled = false, refersTo = null, className = '', onFocus, onBlur, title }) => {
	let labels = {};
	const realIndex = (selectedIndex == undefined ? 1 : selectedIndex) - 1;

	return (
		<div className="slide">
		<h3 className="slide-title">{title}</h3>
			{stops.length !== undefined &&
				stops.forEach((stop, index) => {
				labels[index+1] = stop.title;
			})}
			<Slider
				min={1}
				max={stops.length}
				value={selectedIndex || 1}
				labels={labels}
				className={title}
				onChange={(event) => {selectionHandler(event, statePosition)}} />
			<section>
				<div className="flex">

					{stops[realIndex].image != false
						?
						<img className="" src={stops[realIndex].image} alt={stops[realIndex].title} title={stops[realIndex].title} />
						:
						 <img className="img-none" src="https://w2.buildingservice.com/wp-content/uploads/2019/03/iconfinder_none.svg" />
					}
					<div className='slider-content'>
						<h3>{stops[realIndex].title}</h3>
						<div className="wysiwyg" dangerouslySetInnerHTML={{__html: stops[realIndex].content}} />
					</div>
				</div>

			</section>
		</div>
	);
};

Slide.propTypes = {
	stops: PropTypes.array.isRequired,
	selectedIndex: PropTypes.number,
	selectionHandler: PropTypes.func.isRequired,
	error: PropTypes.string,
	refersTo: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func
}

export default Slide;



// WEBPACK FOOTER //
// ./src/components/step/Slide.js